<template>
  <div class="rs-pagination">
    <div>
      <button :disabled="currentPage <= 1" @click="changePage(currentPage - 1)">
        &lt; <span v-html="strings['Previous']"/>
      </button>
    </div>

    <span>{{ currentPage }} / {{ totalPages }}</span>

    <div>
      <button :disabled="currentPage >= totalPages" @click="changePage(currentPage + 1)">
        <span v-html="strings['Next']"/> &gt;
      </button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    totalPages: {
      type: Number,
      required: true,
    },
    currentPage: {
      type: Number,
      required: true,
    },
    strings: {
      type: Object,
      required: true,
    },
  },
  methods: {
    changePage(page) {
      if (page >= 1 && page <= this.totalPages) {
        this.$emit("page-changed", page);
      }
    },
  },
  watch: {
    currentPage(newPage) {
      // if (newPage < 1 || newPage > this.totalPages) {
      //   this.changePage(1);
      // }
      // console.log("currentPage", newPage);
    },
  },
};
</script>
